import { GetEventChannelResponse } from "@shared/types/common";
import { getEmail } from "@shared/services/tour/mockedApis/helpers.ts";

import json from "../json/inAppNotificationsEventChannel.json";

export default async () => {
  const parsedJson = JSON.parse(
    JSON.stringify(await json),
  ) as GetEventChannelResponse;

  parsedJson.email = await getEmail();

  return parsedJson;
};
